import React from "react";
import { Routes, Route } from "react-router-dom";
import "./CSS/Global.css";
import Header from "./Components/Header";
import Home from "./Components/Home";
import AboutPage from "./Components/AboutPage";
import Footer from "./Components/Footer";
import ServicePage from "./Components/ServicePage";
import ContactPage from "./Components/ContactPage";
import PersonalLoanInfo from "./Components/PersonalLoanInfor";
import BusinessLoanInfo from "./Components/BusinessLoanInfo";
import HomeLoanInfo from "./Components/HomeLoanInfo";
import MortgageLoanInfo from "./Components/MortgageLoanInfo";
import AutomobileLoanInfo from "./Components/AutoMobileLoanInfo";
import AgriculturalLoanInfo from "./Components/AgricultureLoanInfo";
import LoanAgainstSharesInfo from "./Components/LoanAgainstSharesInfo";
import EducationLoanInfo from "./Components/EducationLoanInfo";
import GoldLoanInfo from "./Components/GoldLoanInfo";
import LoanEMICalculator from "./Components/LoanEMICalulator";
import HomeMainSection from "./Components/HomeMainSection";
import ApplyNow from "./Components/ApplyNow";
import ScrollToTop from "./Components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import ChannelPartners from "./Components/ChannelPartner";
import CarLoanInfo from "./Components/CarLoanInfo";
import WorkingCapitalInfo from "./Components/WorkingCapitalInfo";
import WhatsAppButton from "./Components/WhatsAppButton";
import GeneralInsuranceInfo from "./Components/GeneralInsuranceInfo";
import LifeInsuranceInfo from "./Components/LifeInsuranceInfo";
import MutualFundsInfo from "./Components/MutualFundsInfo";
import HealthInsuranceInfo from "./Components/HealthInsuranceInfo";
import VehicleInsuranceInfo from "./Components/VehicleInsuranceInfo";
import Profile from "./Components/Profile";

const App = () => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-money-vision-advisory" element={<AboutPage />} />
        <Route path="/loan-services-india" element={<ServicePage />} />
        <Route path="/contact-loan-experts" element={<ContactPage />} />
        <Route path="/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<PersonalLoanInfo />} />
        <Route path="/business-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<BusinessLoanInfo />} />
        <Route path="/home-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<HomeLoanInfo />} />
        <Route path="/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<MortgageLoanInfo />} />
        <Route path="/education-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<EducationLoanInfo />} />
        <Route path="/gold-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<GoldLoanInfo />} />
        <Route path="/car-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<CarLoanInfo />} />
        <Route path="/working-capital-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<WorkingCapitalInfo />} />
        <Route path="/emi-calculator-loan" element={<LoanEMICalculator />} />
        <Route path="/home-updates" element={<HomeMainSection />} />
        <Route path="/apply-loan-online" element={<ApplyNow />} />
        <Route path="/channel-partner" element={<ChannelPartners />} />
        <Route path="/loan-against-shares-mumbai-thane-palghar-maharashtra-delhi-india" element={<LoanAgainstSharesInfo />} />
        <Route path="/general-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<GeneralInsuranceInfo />} />
        <Route path="/life-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<LifeInsuranceInfo />} />
        <Route path="/mutual-funds-mumbai-thane-palghar-maharashtra-delhi-india" element={<MutualFundsInfo />} />
        <Route path="/health-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<HealthInsuranceInfo />} />
        <Route path="/vehicle-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<VehicleInsuranceInfo />} />
        <Route path="/Mr-Surendra-Profile" element={<Profile />} />
      </Routes>
      <WhatsAppButton />
      <Footer />
      <ToastContainer/>
    </>
  );
};

export default App;
